function isWindowWithPrebidjs(a) {
    const w = a;
    return !!w
        && typeof w === 'object'
        && 'prebidjs' in w
        && w.prebidjs
        && typeof w.prebidjs.init === 'function'
        && typeof w.prebidjs.doPrebid === 'function';
}
function isPrebidEnabled(win) {
    const vendor = win?.cp_ads_config?.prebidVendor;
    return vendor ? vendor : false;
}
function getOrInitializePrebidjsTagSdk(win, userData, gdpr) {
    if (isWindowWithPrebidjs(win)) {
        return Promise.resolve(win.prebidjs);
    }
    return ensureCiaoPrebidLoaded(win).then(() => new Promise((resolve, reject) => {
        const started = Date.now();
        const timeout = 10000;
        const interval = 100;
        const check = () => {
            if (isWindowWithPrebidjs(win)) {
                console.log('[PREBID] Prebid.js sdk caricato');
                resolve(win.prebidjs);
                return;
            }
            if (Date.now() - started >= timeout) {
                reject('[PREBID] ciaoprebid.js caricato ma non disponibile');
                return;
            }
            setTimeout(check, interval);
        };
        check();
    }));
}
function buildCiaoPrebidSrc(win) {
    const v = win.cp_ads_config?.prebidVendor?.version;
    if (!v)
        throw new Error('[PREBID] cp_ads_config.prebidVendor.version non trovato');
    return `https://assets.fanpage.it/ciaoprebid-js/${v}/adstack/sdk/doPrebid.js`;
}
function ensureCiaoPrebidLoaded(win, doc = document) {
    const src = buildCiaoPrebidSrc(win);
    if (doc.querySelector(`script[src="${src}"]`))
        return Promise.resolve();
    return new Promise((resolve, reject) => {
        const s = doc.createElement('script');
        s.async = true;
        s.src = src;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error('[PREBID] Errore nel caricamento di ciaoprebid.js'));
        doc.head.appendChild(s);
    });
}
export class PrebidjsImpl {
    window;
    gdprPromise;
    userData;
    constructor(window, gdprPromise, userData) {
        this.window = window;
        this.gdprPromise = gdprPromise;
        this.userData = userData;
    }
    loadSdk() {
        return getOrInitializePrebidjsTagSdk(this.window, this.userData, this.gdprPromise)
            .then((prebidjs) => {
            this.window.prebidjs = prebidjs;
            return prebidjs;
        })
            .catch((error) => {
            console.error(error);
            throw error;
        });
    }
    doPrebid(baseSlots) {
        if (!isPrebidEnabled(this.window)) {
            console.info('[PREBID] Disabilitato via config');
            return Promise.resolve(undefined);
        }
        return this.loadSdk()
            .then((prebidjs) => {
            return new Promise((resolve) => {
                prebidjs.preparePrebidSlots(baseSlots).then((slots) => {
                    prebidjs.doPrebid(slots, (bidsTarg) => {
                        console.log('[PREBID] Bids :', bidsTarg);
                        resolve(bidsTarg);
                        return bidsTarg;
                    });
                });
            })
                .catch((error) => {
                console.error('[PREBID] doPrebid error: ', error);
                throw error;
            });
        });
    }
}
